import { render, staticRenderFns } from "./viewSocial.vue?vue&type=template&id=0fc35da6&scoped=true"
import script from "./viewSocial.vue?vue&type=script&lang=js"
export * from "./viewSocial.vue?vue&type=script&lang=js"
import style0 from "./viewSocial.vue?vue&type=style&index=0&id=0fc35da6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc35da6",
  null
  
)

export default component.exports